module.exports = __webpack_public_path__ + "static/cdc-9fb30eb08b94880b2d3434b4d30b50a2.jpg";